// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CreateBreederBinding, CreateBreederBindingSchema } from 'api/gen/CreateBreederBinding';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateBreederBindingManagerBaseObject, ValidateBreederBindingManagerBaseObjectSchema } from 'api/gen/ValidateBreederBindingManagerBaseObject';

const requiredPart = t.interface({
  tag: t.literal('ValidateCreateBreederBindingManager'),
  binding: t.union([CreateBreederBindingSchema, t.null]),
});

export const ValidateCreateBreederBindingManagerSchema = excess(t.intersection([ValidateBreederBindingManagerBaseObjectSchema.type, requiredPart]));

export interface ValidateCreateBreederBindingManager extends t.TypeOf<typeof ValidateCreateBreederBindingManagerSchema> {}
